import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, CalendarCheck, Download, Gift } from 'lucide-react';
import { Button } from './Button';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/eDJ27mVSdoHBNV6xPKMFdm/Diseno_sin_titulo_(65).png';
const trust = [{
  icon: BookOpen,
  label: '6 Complete Volumes'
}, {
  icon: CalendarCheck,
  label: '150 Ready-to-Coach Sessions'
}, {
  icon: Gift,
  label: '5 Strategic Bonuses'
}, {
  icon: Download,
  label: 'Immediate Access'
}];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-14 px-4 overflow-hidden bg-sand-light" data-id="element-179" data-mp="xaxfboi3nqll">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-180" data-mp="sa02lrfuzorh">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-181" data-mp="nb6ktmtjhbli">
          <p className="text-forest font-display font-extrabold text-xs sm:text-sm tracking-[0.2em] mb-3 sm:mb-4" data-id="element-182" data-mp="381nuv9jxgt3y">
            MOUNTAIN BIKE COACH READY
          </p>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight mb-4 sm:mb-6 text-navy" data-id="element-183" data-mp="3o85b7b3xi14k">
            Solve an entire year of MTB coaching sessions in just{' '}
            <span className="text-orange" data-id="element-184" data-mp="3e8mtz2fektg7">5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-[360px] sm:max-w-xl md:max-w-3xl mb-6 sm:mb-8" data-id="element-185" data-mp="30hhohjpct6xy">
          <img src={HERO_IMAGE} alt="Mountain Bike Coach Ready: 6-volume box set, class finder tablet app and 5 bonus guides" className="w-full h-auto drop-shadow-2xl" data-id="element-186" data-mp="2violwmblv0ck" />
        </motion.div>

        <p className="text-sm sm:text-lg md:text-xl text-forest font-semibold leading-snug max-w-2xl mx-auto mb-2" data-id="element-187" data-mp="2ljgxn43c1lao">
          The Complete 6-in-1 MTB Coaching System for Mountain Bike Coaches
        </p>
        <p className="text-sm sm:text-base text-muted leading-snug max-w-2xl mx-auto mb-6 sm:mb-8" data-id="element-188" data-mp="najhbnrq6df0">
          150 Ready-to-Coach Sessions · 6 Complete Volumes · Technical Progressions · Visual
          Coaching Tools · 5 Strategic Bonuses
        </p>

        <div className="flex justify-center mb-6 sm:mb-8 w-full" data-id="element-189" data-mp="1b0vzrskljsju">
          <Button className="text-sm sm:text-lg md:text-xl py-3.5 sm:py-5 px-6 sm:px-10" data-id="element-190" data-mp="1b04at0li8t2j">
            GET THE COMPLETE 6-IN-1 MTB COACHING SYSTEM NOW
            <ArrowRight size={20} aria-hidden="true" className="shrink-0" data-id="element-191" data-mp="1126m6bzqgu9e" />
          </Button>
        </div>

        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs sm:text-sm text-navy font-medium" data-id="element-192" data-mp="x1wbim0zxfo7">
          {trust.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5" data-id="element-193" data-mp="3hrd9yx6dbe0y">
              <Icon size={15} className="text-forest" aria-hidden="true" data-id="element-194" data-mp="3hq23uqpg9u6o" />
              <span data-id="element-195" data-mp="1xacj1d51o1xz">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}